import { Text } from 'ui/components/primitives';

import { Container } from './AboutWithdrawal.styles';

import type { AboutWithdrawalProps } from './AboutWithdrawal.d';

export const AboutWithdrawalBase = ({ address, testId }: AboutWithdrawalProps) => (
  <Container.Card data-testid={testId}>
    <Container.OrderInfo>
      <Text variant="body-large-short">Sobre a retirada</Text>

      {address && <Text variant="auxiliar-small">{`Endereço para retirar: ${address}`}</Text>}

      <Text variant="auxiliar-small">
        Apresente o número do pedido, um documento oficial com foto e defina a forma de pagamento na
        retirada do seu pedido
      </Text>
    </Container.OrderInfo>
  </Container.Card>
);

export default AboutWithdrawalBase;
